// extracted by mini-css-extract-plugin
export var active = "_9t-d";
export var blink = "_9t-e";
export var container = "_9t-5";
export var controls = "_9t-0";
export var controlsRight = "_9t-1";
export var fakeCursor = "_9t-c";
export var hidden = "_9t-b";
export var quillContainerSmall = "_9t-7";
export var quillEditor = "_9t-6";
export var quillEditorSmall = "_9t-8";
export var quillFormatButtons = "_9t-a";
export var quillToolbar = "_9t-9";
export var removePadding = "_9t-2";
export var state = "_9t-3";
export var stateTitle = "_9t-4";